import { ApiService } from "./ApiService";

export class PppoePsbService {

    static uri = '/pppoe-psb';

    static get({ params }) {
        return ApiService.get(`${this.uri}`, {
            params,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static create({ data }) {
        return ApiService.post(`${this.uri}/create`, data);
    }

    static delete({ id }) {
        return ApiService.delete(`${this.uri}/delete/${id}`);
    }
}